import { memo, useContext, useEffect } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";
import InputText from "./InputText";
import InputTel from "./InputTel";
import InputEmail from "./InputEmail";
import Subject from "./Subject";

const FormBusiness = memo(() => {
	const { inputs, setInputs, errors, setErrors } = useContext(Data);

	useEffect(() => {
		setTimeout(() => {
			setErrors({
				...errors,
				company: inputs.company === null ? "*必須" : null,
				url: inputs.url === null ? "*必須" : null,
				industry: inputs.industry === "default" ? "*必須" : null,
				tel: inputs.tel === null ? "*必須" : null,
				subject: null,
			});
		}, 10);
		return () => {
			setErrors({
				...errors,
				company: null,
				url: null,
				industry: null,
				tel: null,
			});
		};
	}, []);

	const setIndustry = (e) => {
		setErrors(() => ({ ...errors, industry: null }));
		setInputs(() => ({ ...inputs, industry: e.target.value }));
	};

	const industryList = [
		"ハウスメーカー",
		"インテリアコーディネーター",
		"設計事務所",
		"工務店",
		"店舗",
		"ホテル",
		"その他",
	];

	return (
		<div className={styles.formMain}>
			<h3 className={`en ${styles.headline}`}>
				PERSONAL<span>氏名をご入力</span>
			</h3>
			<div>
				<InputText
					label={"担当者名"}
					name={"name"}
					max={20}
					placeholder={"ノイエス太郎"}
					require
				/>
				<InputText
					label={"ふりがな"}
					name={"furigana"}
					max={20}
					placeholder={"のいえすたろう"}
					require
				/>
				<InputText
					label={"企業名"}
					name={"company"}
					max={20}
					placeholder={"NOYES"}
					require
				/>
				<InputText
					label={"企業URL"}
					name={"url"}
					placeholder={"https:://ny-k.co.jp"}
					require
				/>
				<InputTel label={"電話番号"} require />
				<InputEmail
					label={"メールアドレス"}
					name={"email"}
					placeholder={"noyes@ny-k.co.jp"}
					require
					check
				/>
				<div className={styles.selectBox}>
					<p className="bold">
						業種<span>{errors.industry}</span>
					</p>
					<div>
						<select
							name="industry"
							onChange={setIndustry}
							value={inputs.industry}
						>
							<option disabled selected value="default">
								選択してください
							</option>
							{industryList.map((item, index) => {
								return (
									<option key={index} value={item}>
										{item}
									</option>
								);
							})}
						</select>
					</div>
				</div>
			</div>
		</div>
	);
});

export default FormBusiness;
